/* tslint:disable */

declare var Object: any;
export interface ViewSearchEmpInterface {
  "userId": number;
  "identityNo"?: number;
  "gender"?: number;
  "status"?: number;
  "firstName"?: string;
  "lastName"?: string;
  "userName": string;
  "address"?: string;
  "phone"?: string;
  "middleName"?: string;
  "fullName"?: string;
  "spvName"?: string;
  "empId"?: string;
  "empNo"?: string;
  "positionId"?: number;
  "email"?: string;
  "posCode"?: string;
  "posNameEn"?: string;
  "companyId"?: number;
  "spvParent"?: string;
  "spvPath"?: string;
  "endDate"?: Date;
  "startDate"?: Date;
  "photo"?: string;
}

export class ViewSearchEmp implements ViewSearchEmpInterface {
  "userId": number;
  "identityNo": number;
  "gender": number;
  "status": number;
  "firstName": string;
  "lastName": string;
  "userName": string;
  "address": string;
  "phone": string;
  "middleName": string;
  "fullName": string;
  "spvName": string;
  "empId": string;
  "empNo": string;
  "positionId": number;
  "email": string;
  "posCode": string;
  "posNameEn": string;
  "companyId": number;
  "spvParent": string;
  "spvPath": string;
  "endDate": Date;
  "startDate": Date;
  "photo": string;
  constructor(data?: ViewSearchEmpInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ViewSearchEmp`.
   */
  public static getModelName() {
    return "ViewSearchEmp";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ViewSearchEmp for dynamic purposes.
  **/
  public static factory(data: ViewSearchEmpInterface): ViewSearchEmp{
    return new ViewSearchEmp(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ViewSearchEmp',
      plural: 'ViewSearchEmps',
      path: 'ViewSearchEmps',
      properties: {
        "userId": {
          name: 'userId',
          type: 'number'
        },
        "identityNo": {
          name: 'identityNo',
          type: 'number'
        },
        "gender": {
          name: 'gender',
          type: 'number'
        },
        "status": {
          name: 'status',
          type: 'number'
        },
        "firstName": {
          name: 'firstName',
          type: 'string'
        },
        "lastName": {
          name: 'lastName',
          type: 'string'
        },
        "userName": {
          name: 'userName',
          type: 'string'
        },
        "address": {
          name: 'address',
          type: 'string'
        },
        "phone": {
          name: 'phone',
          type: 'string'
        },
        "middleName": {
          name: 'middleName',
          type: 'string'
        },
        "fullName": {
          name: 'fullName',
          type: 'string'
        },
        "spvName": {
          name: 'spvName',
          type: 'string'
        },
        "empId": {
          name: 'empId',
          type: 'string'
        },
        "empNo": {
          name: 'empNo',
          type: 'string'
        },
        "positionId": {
          name: 'positionId',
          type: 'number'
        },
        "email": {
          name: 'email',
          type: 'string'
        },
        "posCode": {
          name: 'posCode',
          type: 'string'
        },
        "posNameEn": {
          name: 'posNameEn',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "spvParent": {
          name: 'spvParent',
          type: 'string'
        },
        "spvPath": {
          name: 'spvPath',
          type: 'string'
        },
        "endDate": {
          name: 'endDate',
          type: 'Date'
        },
        "startDate": {
          name: 'startDate',
          type: 'Date'
        },
        "photo": {
          name: 'photo',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ViewSearchEmp.ts